export default __webpack_public_path__ + "static/media/icon-assinatura.2ac21fea.svg";